import {combineReducers} from 'redux';

import {authentication} from './authentication.reducer';
import {alert} from './alert.reducer';
import {sources} from './sources.reducer';
import {currentSource} from './currentSource.reducer';
import {gists} from './gists.reducer';
import {order} from './order.reducer';
import {users} from './users.reducer';
import {subscriptions} from "./subscriptions.reducer";
import {registration} from "./registration.reducer";
import {integrations} from "./integrations.reducer";
import {historyInfo} from "./historyInfo.reducer";
import {uploads} from "./uploads.reducer";
import {gtmMetaReducer} from "../_helpers/analytics/analytics.helper";
import {userActionTypes} from "../_constants";
import {stateInitializer} from "./stateInitializer";
import {support} from "./support.reducer";
import {blog} from "./blog.reducer";

const appReducer = combineReducers({
  authentication,
  alert,
  sources,
  gists,
  currentSource,
  order,
  users,
  subscriptions,
  registration,
  integrations,
  historyInfo,
  uploads,
  support,
  blog,
  gtmMetaReducer
});

const rootReducer = (state, action) => {
  /*
   * Default app handler for user log out
   */
  if (action.type === userActionTypes.LOGOUT) {
    /*
     * Assigning 'undefined' should have initialized the store with initial state
     * However, issue was seen when there was a 'browser-refresh'.
     * To fix it, pulling the initial state and explicitly setting here
     */
    state = stateInitializer.getInitialStateForStore();      // assign store's initial state
  }
  return appReducer(state, action)
};

export default rootReducer;